import { Box, Divider, Flex, Switch, Text } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { BsBellFill } from 'react-icons/bs';
import { PrimaryButton } from '../../../components/CustomButton';
import FullPageLoader from '../../../components/FullPageLoader';

import { AuthContext } from '../../../context/authContext';
import { getTenantProfileSettings, postTenantProfileSetting } from '../service';

const Notifications = () => {
  const { userInfo } = useContext(AuthContext);
  const { userId, tenantCode } = userInfo;

  const [isLoading, setIsLoading] = useState(false);
  const [tenantProfileSettings, setTenantProfileSettings] = useState({});
  const [invite, setInvite] = useState(tenantProfileSettings?.invite);
  const [errand, setErrand] = useState(tenantProfileSettings?.errand);
  const [wallet, setWallet] = useState(tenantProfileSettings?.wallet);
  const [market, setMarket] = useState(tenantProfileSettings?.market);
  const [advert, setAdvert] = useState(tenantProfileSettings?.advert);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    getTenantProfileSettings(userId, setIsLoading, setTenantProfileSettings);
  }, [userId, refresh]);

  useEffect(() => {
    const { invite, errand, wallet, market, advert } = tenantProfileSettings;
    setInvite(invite);
    setErrand(errand);
    setWallet(wallet);
    setMarket(market);
    setAdvert(advert);
  }, [tenantProfileSettings]);

  const handleSave = () => {
    const payload = {
      userId,
      tenantCode,
      invite,
      errand,
      market,
      wallet,
      advert,
    };
    console.log(payload);
    postTenantProfileSetting(payload, setIsLoading).then(() =>
      setRefresh(!refresh)
    );
  };
  return isLoading ? (
    <FullPageLoader />
  ) : (
    <Box bg='#F9F9F9' borderRadius='10px' p='20px 20px' mt='15px'>
      <Flex align='center'>
        <BsBellFill size='1.5em' />
        <Text pl='10px'>Notifications</Text>
      </Flex>
      <Divider py='2px' orientation='horizontal' w='100%' />

      <Flex py='1' justify='space-between' align='center'>
        <Text pt='10px'>Invite</Text>
        <Switch
          size='sm'
          name='invite'
          id='invite'
          onChange={() => {
            setInvite(!invite);

            // postTenantProfileSetting(payload, setIsLoading);
          }}
          // onChange={() => handleNotificationsSwitch(!invite)}
          defaultChecked={tenantProfileSettings?.invite}
          value={tenantProfileSettings?.invite}
        />
      </Flex>

      {/* <Flex py='1' justify='space-between' align='center'>
        <Text pt='10px'>Errands</Text>
        <Switch
          size='sm'
          name='errand'
          onChange={() => setErrand(!errand)}
          // onChange={handleNotificationsSwitch}
          defaultChecked={tenantProfileSettings.errand}
          value={tenantProfileSettings?.errand}
        />
      </Flex> */}

      <Flex py='1' justify='space-between' align='center'>
        <Text pt='10px'>E wallet</Text>
        <Switch
          size='sm'
          name='wallet'
          onChange={() => setWallet(!wallet)}
          // onChange={handleNotificationsSwitch}
          defaultChecked={tenantProfileSettings.wallet}
          value={tenantProfileSettings.wallet}
        />
      </Flex>

      <Flex py='1' justify='space-between' align='center'>
        <Text pt='10px'>Market Place</Text>
        <Switch
          size='sm'
          name='market'
          onChange={() => setMarket(!market)}
          // onChange={handleNotificationsSwitch}
          defaultChecked={tenantProfileSettings.market}
          value={tenantProfileSettings.market}
        />
      </Flex>

      <Flex py='1' justify='space-between' align='center'>
        <Text pt='10px'>Advert</Text>
        <Switch
          size='sm'
          name='advert'
          onChange={() => setAdvert(!advert)}
          // onChange={handleNotificationsSwitch}
          defaultChecked={tenantProfileSettings.advert}
          value={tenantProfileSettings.advert}
        />
      </Flex>
      <Flex pt='5'>
        <PrimaryButton btnText='Save settings' w='150px' onClick={handleSave} />
      </Flex>
    </Box>
  );
};

export default Notifications;
